import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import { PlayerConfigurationDefinition} from '../models/player-config-list-option';

export const playerConfigurationDefinitionActionTypes = {
  LOAD: type('[Player config list ] Load'),
  LOAD_CLIENT: type('[Player config list ] Load client'),
  LOAD_SUCCESS: type('[Player config list ] Load Success'),
  LOAD_FAIL: type('[Player config list ] Load Error'),
  IS_USED: type('[Player config list ] Is used'),
  CLEAR: type('[Player config list ] CLEAR'),
};

export class LoadPlayerConfigurationDefinitionAction implements Action {
  readonly type = playerConfigurationDefinitionActionTypes.LOAD;
  constructor() {  }
}

export class LoadPlayerConfigurationDefinitionClientAction implements Action {
  readonly type = playerConfigurationDefinitionActionTypes.LOAD_CLIENT;
  constructor() {  }
}

export class LoadPlayerConfigurationDefinitionSuccessAction implements Action {
  readonly type = playerConfigurationDefinitionActionTypes.LOAD_SUCCESS;
  constructor(public payload?: PlayerConfigurationDefinition[]) {}
}

export class LoadPlayerConfigurationDefinitionFailAction implements Action {
  readonly type = playerConfigurationDefinitionActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}

export class IsUsedPlayerConfigurationDefinitionAction implements Action {
  readonly type = playerConfigurationDefinitionActionTypes.IS_USED;
  constructor(public payload?: {name: string, value: boolean}) {}
}
export class ClearPlayerConfigurationDefinitionAction implements Action {
  readonly type = playerConfigurationDefinitionActionTypes.CLEAR;
  constructor() {}
}
